// @ts-strict-ignore
import React from 'react'
import { Table } from '../../../components/ui/Table'
import { updateStatusString } from '../../../constants/update_status'
import { format } from 'date-fns'
import { updateSnapshotAdTypeString } from '../../../config'
import { TableHooks, useTableHooks } from '../../../packages/blueprint-components/src/useTableHooks'
import { useRecoilValue } from 'recoil'
import { unsuccessfulSnapshots } from './update_details_state'
import Snapshot = Models.Snapshot
import { Column } from '../../../types/table'

export const UnsuccessfulSnapshots = () => {
    const items = useRecoilValue(unsuccessfulSnapshots)

    const tableHooks: TableHooks<Snapshot> = useTableHooks(() =>
        Promise.resolve({
            data: { data: [] },
        }),
    )
    tableHooks.items = items ?? []

    const columns: Column<Snapshot, any>[] = [
        {
            key: 'id',
            title: 'Snapshot Id',
        },
        { key: 'snapshot_id' },
        {
            key: 'status_id',
            title: 'Status',
            cell: (row) => {
                return (
                    <span className="whitespace-nowrap">{updateStatusString(row.status_id)}</span>
                )
            },
        },
        {
            key: 'type',
            cell: ({ type }) => updateSnapshotAdTypeString(type),
        },
        {
            key: 'created_at',
            cell: (row) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.created_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
        {
            key: 'updated_at',
            cell: (row) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.updated_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
        {
            key: 'params',
            cell: (row) => {
                return (
                    <span className="whitespace-nowrap">
                        {row.params ? JSON.stringify(row.params) : ''}
                    </span>
                )
            },
        },
    ]

    console.log('items', tableHooks.items)

    return (
        <Table
            name="Unsuccessful Snapshots"
            showHeader
            className="w-full"
            filters={null}
            canSelect={false}
            columnSelection={false}
            columns={columns}
            tableHooks={tableHooks}
            onSelectChange={null}
            height={300}
        />
    )
}
